/**
 * Role mutation hooks split out of RoleEditor.tsx so the editor file
 * only exports React components - avoids the
 * ``react-refresh/only-export-components`` ESLint warning that fires
 * when a component file also exports a non-component value.
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";

import type { RoleDetailResponse } from "@tilt/admin-sdk";

import { apiClient } from "@/lib/api";

/** Soft-delete a role + invalidate the relevant query caches. The
 *  host page owns its own confirm UI; this hook is just the mutation
 *  glue. */
export function useDeleteRoleMutation(): ReturnType<
  typeof useMutation<RoleDetailResponse, unknown, string>
> {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => apiClient.deleteRole(id),
    onSuccess: (resp) => {
      qc.invalidateQueries({ queryKey: ["roles", "list"] });
      qc.invalidateQueries({ queryKey: ["roles", "detail", resp.role.id] });
    },
  });
}
